let wrap = document.scrollingElement || getScrollingElement()
function getScrollingElement () {
  if (/Android/i.test(navigator.userAgent)) {
    return document.documentElement
  } else {
    return document.body
  }
}
export default {
  data () {
    return {
      _scrollTop: 0
    }
  },
  methods: {
    preventScroll () {
      this._scrollTop = wrap.scrollTop
      document.body.style.position = 'fixed'
      document.body.style.width = '100%'
      document.body.style.top = -this._scrollTop + 'px'
    },
    allowScroll () {
      document.body.style.position = ''
      document.body.style.width = ''
      document.body.style.top = ''
      wrap.scrollTop = this._scrollTop
    }
  },
  beforeDestroy () {
    this.allowScroll()
  }
}
